/* eslint-disable */
import _ from 'underscore';

(function (window1, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = factory();
  } else {
    // Browser Global
    window.PulpoValidator = factory();
  }
}(this, () => { /**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
  // Going sloppy to avoid 'use strict' string cost, but strict practices should
  // be followed.
  /* jslint sloppy: true */
  /* global setTimeout: false */

  let requirejs; let require; let
    define;
  (function (undef) {
    let main; let req; let makeMap; let handlers;
    const defined = {};
    const waiting = {};
    let config = {};
    const defining = {};
    const hasOwn = Object.prototype.hasOwnProperty;
    const aps = [].slice;
    const jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
      return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
      let nameParts; let nameSegment; let mapValue; let foundMap; let lastIndex;
      let foundI; let foundStarMap; let starI; let i; let j; let part;
      let baseParts = baseName && baseName.split('/');
      const { map } = config;
      const starMap = (map && map['*']) || {};

      // Adjust any relative paths.
      if (name && name.charAt(0) === '.') {
        // If have a base name, try to normalize against it,
        // otherwise, assume it is a top-level require that will
        // be relative to baseUrl in the end.
        if (baseName) {
          // Convert baseName to array, and lop off the last part,
          // so that . matches that "directory" and not name of the baseName's
          // module. For instance, baseName of "one/two/three", maps to
          // "one/two/three.js", but we want the directory, "one/two" for
          // this normalization.
          baseParts = baseParts.slice(0, baseParts.length - 1);
          name = name.split('/');
          lastIndex = name.length - 1;

          // Node .js allowance:
          if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
            name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
          }

          name = baseParts.concat(name);

          // start trimDots
          for (i = 0; i < name.length; i += 1) {
            part = name[i];
            if (part === '.') {
              name.splice(i, 1);
              i -= 1;
            } else if (part === '..') {
              if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                // End of the line. Keep at least one non-dot
                // path segment at the front so it can be mapped
                // correctly to disk. Otherwise, there is likely
                // no path mapping for a path starting with '..'.
                // This can still fail, but catches the most reasonable
                // uses of ..
                break;
              } else if (i > 0) {
                name.splice(i - 1, 2);
                i -= 2;
              }
            }
          }
          // end trimDots

          name = name.join('/');
        } else if (name.indexOf('./') === 0) {
          // No baseName, so this is ID is resolved relative
          // to baseUrl, pull off the leading dot.
          name = name.substring(2);
        }
      }

      // Apply map config if available.
      if ((baseParts || starMap) && map) {
        nameParts = name.split('/');

        for (i = nameParts.length; i > 0; i -= 1) {
          nameSegment = nameParts.slice(0, i).join('/');

          if (baseParts) {
            // Find the longest baseName segment match in the config.
            // So, do joins on the biggest to smallest lengths of baseParts.
            for (j = baseParts.length; j > 0; j -= 1) {
              mapValue = map[baseParts.slice(0, j).join('/')];

              // baseName segment has  config, find if it has one for
              // this name.
              if (mapValue) {
                mapValue = mapValue[nameSegment];
                if (mapValue) {
                  // Match, update name to the new value.
                  foundMap = mapValue;
                  foundI = i;
                  break;
                }
              }
            }
          }

          if (foundMap) {
            break;
          }

          // Check for a star map match, but just hold on to it,
          // if there is a shorter segment match later in a matching
          // config, then favor over this star map.
          if (!foundStarMap && starMap && starMap[nameSegment]) {
            foundStarMap = starMap[nameSegment];
            starI = i;
          }
        }

        if (!foundMap && foundStarMap) {
          foundMap = foundStarMap;
          foundI = starI;
        }

        if (foundMap) {
          nameParts.splice(0, foundI, foundMap);
          name = nameParts.join('/');
        }
      }

      return name;
    }

    function makeRequire(relName, forceSync) {
      return function () {
        // A version of a require function that passes a moduleName
        // value for items that may need to
        // look up paths relative to the moduleName
        return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
      };
    }

    function makeNormalize(relName) {
      return function (name) {
        return normalize(name, relName);
      };
    }

    function makeLoad(depName) {
      return function (value) {
        defined[depName] = value;
      };
    }

    function callDep(name) {
      if (hasProp(waiting, name)) {
        const args = waiting[name];
        delete waiting[name];
        defining[name] = true;
        main.apply(undef, args);
      }

      if (!hasProp(defined, name) && !hasProp(defining, name)) {
        throw new Error(`No ${name}`);
      }
      return defined[name];
    }

    // Turns a plugin!resource to [plugin, resource]
    // with the plugin being undefined if the name
    // did not have a plugin prefix.
    function splitPrefix(name) {
      let prefix;
      const index = name ? name.indexOf('!') : -1;
      if (index > -1) {
        prefix = name.substring(0, index);
        name = name.substring(index + 1, name.length);
      }
      return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
      let plugin;
      let parts = splitPrefix(name);
      let prefix = parts[0];

      name = parts[1];

      if (prefix) {
        prefix = normalize(prefix, relName);
        plugin = callDep(prefix);
      }

      // Normalize according
      if (prefix) {
        if (plugin && plugin.normalize) {
          name = plugin.normalize(name, makeNormalize(relName));
        } else {
          name = normalize(name, relName);
        }
      } else {
        name = normalize(name, relName);
        parts = splitPrefix(name);
        prefix = parts[0];
        name = parts[1];
        if (prefix) {
          plugin = callDep(prefix);
        }
      }

      // Using ridiculous property names for space reasons
      return {
        f: prefix ? `${prefix}!${name}` : name, // fullName
        n: name,
        pr: prefix,
        p: plugin
      };
    };

    function makeConfig(name) {
      return function () {
        return (config && config.config && config.config[name]) || {};
      };
    }

    handlers = {
      require(name) {
        return makeRequire(name);
      },
      exports(name) {
        const e = defined[name];
        if (typeof e !== 'undefined') {
          return e;
        }
        return (defined[name] = {});
      },
      module(name) {
        return {
          id: name,
          uri: '',
          exports: defined[name],
          config: makeConfig(name)
        };
      }
    };

    main = function (name, deps, callback, relName) {
      let cjsModule; let depName; let ret; let map; let i;
      const args = [];
      const callbackType = typeof callback;
      let usingExports;

      // Use name if no relName
      relName = relName || name;

      // Call the callback to define the module, if necessary.
      if (callbackType === 'undefined' || callbackType === 'function') {
        // Pull out the defined dependencies and pass the ordered
        // values to the callback.
        // Default to [require, exports, module] if no deps
        deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
        for (i = 0; i < deps.length; i += 1) {
          map = makeMap(deps[i], relName);
          depName = map.f;

          // Fast path CommonJS standard dependencies.
          if (depName === 'require') {
            args[i] = handlers.require(name);
          } else if (depName === 'exports') {
            // CommonJS module spec 1.1
            args[i] = handlers.exports(name);
            usingExports = true;
          } else if (depName === 'module') {
            // CommonJS module spec 1.1
            cjsModule = args[i] = handlers.module(name);
          } else if (hasProp(defined, depName)
                           || hasProp(waiting, depName)
                           || hasProp(defining, depName)) {
            args[i] = callDep(depName);
          } else if (map.p) {
            map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
            args[i] = defined[depName];
          } else {
            throw new Error(`${name} missing ${depName}`);
          }
        }

        ret = callback ? callback.apply(defined[name], args) : undefined;

        if (name) {
          // If setting exports via "module" is in play,
          // favor that over return value and exports. After that,
          // favor a non-undefined return value over exports use.
          if (cjsModule && cjsModule.exports !== undef
                        && cjsModule.exports !== defined[name]) {
            defined[name] = cjsModule.exports;
          } else if (ret !== undef || !usingExports) {
            // Use the return value from the function.
            defined[name] = ret;
          }
        }
      } else if (name) {
        // May just be an object definition for the module. Only
        // worry about defining if have a module name.
        defined[name] = callback;
      }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
      if (typeof deps === 'string') {
        if (handlers[deps]) {
          // callback in this case is really relName
          return handlers[deps](callback);
        }
        // Just return the module wanted. In this scenario, the
        // deps arg is the module name, and second arg (if passed)
        // is just the relName.
        // Normalize module name, if it contains . or ..
        return callDep(makeMap(deps, callback).f);
      } if (!deps.splice) {
        // deps is a config object, not an array.
        config = deps;
        if (config.deps) {
          req(config.deps, config.callback);
        }
        if (!callback) {
          return;
        }

        if (callback.splice) {
          // callback is an array, which means it is a dependency list.
          // Adjust args if there are dependencies
          deps = callback;
          callback = relName;
          relName = null;
        } else {
          deps = undef;
        }
      }

      // Support require(['a'])
      callback = callback || function () {};

      // If relName is a function, it is an errback handler,
      // so remove it.
      if (typeof relName === 'function') {
        relName = forceSync;
        forceSync = alt;
      }

      // Simulate async callback;
      if (forceSync) {
        main(undef, deps, callback, relName);
      } else {
        // Using a non-zero value because of concern for what old browsers
        // do, and latest browsers "upgrade" to 4 if lower value is used:
        // http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
        // If want a value immediately, use require('id') instead -- something
        // that works in almond on the global level, but not guaranteed and
        // unlikely to work in other AMD implementations.
        setTimeout(() => {
          main(undef, deps, callback, relName);
        }, 4);
      }

      return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
      return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
      // This module may not have dependencies
      if (!deps.splice) {
        // deps is not an array, so probably means
        // an object literal or factory function for
        // the value. Adjust args.
        callback = deps;
        deps = [];
      }

      if (!hasProp(defined, name) && !hasProp(waiting, name)) {
        waiting[name] = [name, deps, callback];
      }
    };

    define.amd = {
      jQuery: true
    };
  }());

  define('almond', () => {});


  /* jshint camelcase: false */

  define('Defaults', [], () => {
    const defaultObject = {};
    /**
   * form schema. It has all the posibles keys with it's types associated.
   */
    defaultObject.schema = {
      id: { type: 'string' },
      version: { type: 'number' },
      fields: {
        type: 'Array', // type of fields property
        child: { // content of an item of field property
          type: { type: 'string' },
          id: { type: 'string' },
          title: { type: 'string' },
          tooltip: { type: 'string' },
          values: { type: 'Array' },
          required: { type: 'boolean' },
          hidden: { type: 'boolean' },
          widget: { type: 'object' },
          validators: { type: 'Array' },
          conditionals: { type: 'Array' },
          default: { type: 'Any' }
        }
      },
      sections: {
        type: 'Array',
        child: {
          title: { type: 'string' },
          id: { type: 'string' },
          fields: { type: 'Array' },
          conditionals: { type: 'Array' },
          hidden: { type: 'boolean' }
        }
      },
      pages: {
        type: 'Array',
        child: {
          title: { type: 'string' },
          id: { type: 'string' },
          content: { type: 'Array' },
          conditionals: { type: 'Array' }
        }
      }
    };

    defaultObject.requiredKeys = Object.keys(defaultObject.schema);

    /**
   * available keys for a form field
   */
    defaultObject.field_keys = Object.keys(defaultObject.schema.fields.child);

    /**
   * the required keys for a form field.
   */
    defaultObject.required_field_keys = [
      'id', 'type', 'title'
    ];

    defaultObject.errors = {
    /**
     * When the object form doesn't follow the schema
     * @variables This key takes one variable: The missing keys.
     */
      FORM_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the schema.',
      /**
     * When the form is not an object
     * @variables This key takes one variable: The type of the form.
     */
      NOT_OBJECT_ERROR: 'The element is not a json object. Got {{0}}',
      /**
     * When a field's type doesn't match with the specified in the schema
     * @variables This key takes three variables: The field that generate the error, the expected type, and the type given.
     */
      TYPE_ERROR: '{{field}} type doesn\'t match with field type in schema. Expected {{0}}, got {{1}}',
      /**
     * When a field type inside a form field doesn't match with the availables field types.
     * @variables This key takes three variables: The field that generate the error, the expected type, and the type given.
     */
      FIELD_TYPE_ERROR: 'Invalid field type: \'{{0}}\'',
      /**
     * When a section specified in a page not exists
     * @variables This key takes two variables: The field that generate the error, and the section id.
     */
      SECTION_NOT_FOUND: 'Section \'{{0}}\' doesn\'t exists.',

      FIELD_NOT_FOUND: 'Field \'{{0}}\' doesn\'t exists.',
      /**
     * When a required key is missing in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is missing.
     */
      DUPLICATED_ERROR: '\'{{0}}\' is duplicated.',

      /**
     * When a field is duplicated between sections
     * @variables This key takes one variables: The field id that is duplicated.
     */
      SECTION_DUPLICATED_FIELD: '\'{{0}}\' field is already in another section.',
      /**
     * When a section is duplicated between pages
     * @variables This key takes one variable: The section id that is duplicated.
     */
      PAGE_DUPLICATED_SECTION: '\'{{0}}\' section is already in another page.',
      /**
     * When a required key is missing in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is missing.
     */
      REQUIRED_KEY: 'The Field is missing the required property \'{{0}}\'',
      /**
     * When a required key is missing in a form section.
     * @variables This key takes one variable: the key that is missing.
     */
      PAGE_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the page schema.',

      SECTION_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the section schema.',

      FIELD_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the field schema.',
      /**
     * When a key is invalid in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is invalid.
     */
      NOT_VALID_KEY: 'Key \'{{0}}\' doesn\'t belong in the schema',

      FIELD_CONDITIONAL_ERROR: 'Conditional \'{{0}}\' is invalid for the referenced field',

      FIELD_VALIDATOR_ERROR: 'Validator \'{{0}}\' is invalid for the field type.',

      FIELD_WIDGET_ERROR: 'Wigdet \'{{0}}\' is invalid for this field type.',

      NO_VALUES_ERROR: 'Select Field type must have a list of values',

      WRONG_FORMED_VALUES: 'Select Values must be an object (key, value)',

      CONDITIONAL_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the conditional schema.',

      VALIDATOR_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the validator schema.',

      VALIDATOR_INVALID_KEY: 'Key \'{{0}}\' doesn\'t belong in the validator schema',

      CONDITIONAL_WRONG_SCHEMA: 'Conditional \'{{0}}\' type must have only a conditional list and no field key.',

      CONDITIONAL_FIELD_NOT_FOUND: 'Field \'{{0}}\' inside conditionals doesn\'t exists.',

      FIELD_WITHOUT_SECTION: 'Field \'{{0}}\' does not belong to any Section.',

      SECTION_WITHOUT_PAGE: 'Section \'{{0}}\' does not belong to any Page.',

      VALIDATOR_INVALID_VALUE: 'Value \'{{0}}\' is invalid for this validator type.'
    };

    return defaultObject;
  });

  /* jshint camelcase: false */

  define('Utils', ['exports', 'Defaults'], (exports, Defaults) => {
    /**
  * Generates error object
  * @method generate_error
  * @param {String} id. The error key.
  * @param {String} field. ID of field that generate the error.
  * @param {String} info. info about the error.
  * @return {Object} Error Object.
  */
    const generate_error = function (id, field, info) {
      let message = Defaults.errors[id];

      if (info) {
        message = message.replace(new RegExp('\\{\\{0}}', 'g'), info);
      }

      if (field === null) {
        return {
          type: id,
          message
        };
      }
      return {
        type: id,
        id: field,
        message
      };
    };

    /**
   * function that generate error object
   */
    const generate_type_error = function (field, innerField, info, extra) {
      let message = Defaults.errors.TYPE_ERROR;

      message = message.replace(new RegExp('\\{\\{field}}', 'g'), innerField);
      message = message.replace(new RegExp('\\{\\{0}}', 'g'), info);
      message = message.replace(new RegExp('\\{\\{1}}', 'g'), extra);
      return {
        type: 'TYPE_ERROR',
        id: field,
        message
      };
    };

    const checkTypes = function (schema, obj) {
      const keys = Object.keys(obj);
      const error_object = [];

      keys.forEach((element) => {
        if (schema[element].type === 'Array') {
          if (!(obj[element] instanceof Array)) {
            error_object.push(generate_type_error(obj.id, element, 'Array', typeof (obj[element])));
          }
        } else if (schema[element].type !== 'Any'
                    && schema[element].type !== typeof (obj[element])) {
          error_object.push(generate_type_error(obj.id, element, schema[element].type, typeof (obj[element])));
        }
      });
      return error_object;
    };

    const checkDuplicates = function (field) {
      let list = _.countBy(field, item => item.id);
      list = _.map(list, (num, id) => { if (num > 1) { return id; } });
      list = _.without(list, undefined);
      const res = [];

      list.forEach((r) => {
        res.push(generate_error('DUPLICATED_ERROR', field.id, r));
      });
      return res;
    };


    exports.generate_error = generate_error;
    exports.checkTypes = checkTypes;
    exports.checkDuplicates = checkDuplicates;
  });

  /* jshint camelcase: false */


  define('Fields', ['Utils', 'Conditionals'], (Utils, Conditionals) => {
    /**
     * Check conditionals, validators and widgets are correct for a given field.
     * @method _checkValidators
     * @param {Object} field to check
     * @param {Object} validProperties. Valid conditionals, validators and widget for the field.
     * @return {Object} Returns a list encountered errors,
     * if no errors returns empty list
     */
    const _checkValidators = function (field, validators) {
      const errors = [];

      if (field.validators && field.validators.length !== 0) {
        _.each(field.validators, (f) => {
          // check conditional required keys
          let diff = _.difference(['type', 'value'], Object.keys(f));
          diff.forEach((d) => {
            errors.push(Utils.generate_error('VALIDATOR_REQUIRED_KEY', field.id, d));
          });
          // check if there are invalid keys
          diff = _.difference(Object.keys(f), ['type', 'value']);
          diff.forEach((d) => {
            errors.push(Utils.generate_error('VALIDATOR_INVALID_KEY', field.id, d));
          });
        });
        if (errors.length === 0) {
          (field.validators).forEach((f) => {
            if (_.contains(['maxLength', 'minLength', 'maxSize'], f.type) && typeof (f.value) !== 'number') {
              errors.push(Utils.generate_error('VALIDATOR_INVALID_VALUE', f.id, f.value));
            }
            if (f.type === 'fileTypes' && !(typeof (f.value) instanceof Array)) {
              errors.push(Utils.generate_error('VALIDATOR_INVALID_VALUE', f.id, f.value));
            }
          });

          const diff = _.difference(
            _.map(field.validators, i => i.type), validators
          );

          if (diff.length > 0) {
            diff.forEach((d) => {
              errors.push(Utils.generate_error('FIELD_VALIDATOR_ERROR', field.id, d));
            });
          }
        }
      }

      return errors;
    };

    const _checkWidgets = function (field, widgets) {
      const errors = [];
      if (field.widget) {
        if (!_.contains(widgets, field.widget.type)) {
          errors.push(Utils.generate_error('FIELD_WIDGET_ERROR', field.id, field.widget.type));
        }
      }

      return errors;
    };

    /**
     * Validates a string type Field
     * @method validate
     * @param {Object} field to validate
     * @return {Object} Returns a list encountered errors,
     * if no errors returns empty list
     */
    const _validateField = function (field, obj, properties) {
      let errors = _checkValidators(field, properties.validators);
      errors = errors.concat(_checkWidgets(field, properties.widgets));
      errors = errors.concat(Conditionals.check(field, properties.conditionals, obj));
      return errors;
    };

    /**
     * Check the correctness of answer type
     * @method _checkAnswerType
     * @param {Object} field to validate
     * @return {Object} Returns a list encountered errors,
     * if no errors returns empty list
     */
    const _checkAnswerType = function (field, answer, type) {
      const error = [];
      if (typeof (answer) !== type) {
        error.concat({
          type: 'ANSWER_TYPE_ERROR',
          id: field.id,
          message: `${answer} expected to be ${type}, got ${typeof (answer)}`
        });
      }
      return error;
    };

    /**
     * Check if an answer satisfy the validations specified
     * @method _checkAnswerValidations
     * @param {Object} field to validate
     * @param {Object} answer to validate
     * @return {Object} Returns a list encountered errors,
     * if no errors returns empty list
     */
    const _checkAnswerValidations = function (field, answer) {
      let errors = [];
      const err = {
        type: 'ANSWER_VALIDATION_ERROR',
        id: field.id,
        message: ''
      };
      _.each(field.validators, (v) => {
        switch (v.type) {
          case 'minLength':
            if (answer.length < v.value) {
              err.message = `${'El largo de la respuesta debe ser mayor a '}${v.value}`;
              errors = errors.concat(err);
            }
            break;

          case 'maxLength':
            if (answer.length > v.value) {
              err.message = `${'El largo de la respuesta debe ser menor a '}${v.value}`;
              errors = errors.concat(err);
            }
            break;

          case 'minValue':
            // TODO: DATE, TIME, DATETIME
            if (answer < parseInt(v.value)) {
              err.message = `${'El valor debe ser mayor a '}${v.value}`;
              errors = errors.concat(err);
            }
            break;

          case 'maxValue':
            // TODO: DATE, TIME, DATETIME
            if (answer > parseInt(v.value)) {
              err.message = `${'El valor debe ser menor a '}${v.value}`;
              errors = errors.concat(err);
            }
            break;

            case 'minChoices':
              if (answer!==undefined && answer.length < v.value) {
                  err.message = `Debe seleccionar al menos ${v.value} ${v.value > 1 ? 'opciones' : 'opción'}`;
                  errors = errors.concat(err);
              }
              break;

            case 'maxChoices':
              if (answer!==undefined && answer.length > v.value) {
                err.message = `Debe seleccionar menos de ${v.value} ${v.value > 1 ? 'opciones' : 'opción'}`;
                errors = errors.concat(err);
              }
              break;


          case 'contains':
            if (answer.indexOf(v.value) === -1) {
              err.message = `${'La respuesta debe contener "'}${v.value}"`;
              errors = errors.concat(err);
            }
            break;

          case 'maxSize':
          case 'fileTypes':
            break;
        }
      });
      return errors;
    };

    return {
      /**
         * String type field properties
         */
      string: {
        conditionals: ['empty', 'equals', 'startsWith', 'endsWith', 'contains'],
        validators: ['minLength', 'maxLength', 'contains'],
        widgets: ['charfield', 'textfield'],
        /**
           * Validates a string type Field
           * @method validate
           * @param {Object} field to validate
           * @param {Object} obj: form.
           * @return {Object} Returns a list encountered errors,
           * if no errors returns empty list
           */
        validate(field, obj) {
          return _validateField(field, obj, this);
        },
        /**
           * Validates an answer given a string field
           * @method validateAnswer
           * @param {Object} field: field specification
           * @param {Object} answer: answer to validate
           * @return {Object} Returns a list encountered errors,
           * if no errors returns empty list
           */
        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'string');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Integer type field properties
         */
      number: {
        conditionals: ['empty', 'equals', 'greater', 'greaterEqual', 'lesserEqual', 'lesser'],
        validators: ['minValue', 'maxValue'],
        widgets: ['numberfield', 'slider'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, parseFloat(answer), 'number');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Boolean type field properties
         */
      boolean: {
        conditionals: ['empty', 'equals'],
        validators: [],
        widgets: ['radio', 'dropdown', 'checkbox'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'boolean');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Date type field properties
         */
      date: {
        conditionals: ['empty', 'equals', 'before', 'after'],
        validators: ['minValue', 'maxValue'],
        widgets: ['calendar', 'datepicker'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Datetime type field properties
         */
      datetime: {
        conditionals: ['empty', 'equals', 'before', 'after'],
        validators: ['minValue', 'maxValue'],
        widgets: ['datepicker', 'datetimepicker'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * time type field properties
         */
      time: {
        conditionals: ['empty', 'equals', 'before', 'after'],
        validators: ['minValue', 'maxValue'],
        widgets: ['numberfield', 'slider'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Duration type field properties
         */
      duration: {
        conditionals: ['empty', 'equals', 'greater', 'greaterEqual', 'lesserEqual', 'lesser'],
        validators: [],
        widgets: ['numberfield', 'slider'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Select type field properties
         */
      select: {
        conditionals: ['empty', 'equals'],
        validators: [],
        widgets: ['radio', 'dropdown', 'checkbox'],
        /**
           * Validates a select type Field
           * @method validate
           * @param {Object} field to validate
           * @return {Object} Returns a list encountered errors,
           * if no errors returns empty list
           */
        validate(field, obj) {
          let errors = [];
          // A Select field must have a list of values.
          if (field.values === undefined || field.values.length === 0) {
            errors.push(Utils.generate_error('NO_VALUES_ERROR', field.id));
          } else {
            field.values.forEach((v) => {
              if (v.key && v.value === undefined) {
                errors.push(Utils.generate_error('WRONG_FORMED_VALUES', field.id));
              }
            });
          }
          errors = errors.concat(_validateField(field, obj, this));
          return errors;
        },

        /**
           * Validates an answer given a select field
           * @method validateAnswer
           * @param {Object} field: field specification
           * @param {Object} answer: answer to validate
           * @return {Object} Returns a list encountered errors,
           * if no errors returns empty list
           */
        validateAnswer(field, answer) {
          const values_keys = _.map(field.values, i => i.key);
          if (!field.hidden && field.required && !_.contains(values_keys, answer) && !_.contains(values_keys, 'otros - ')) {
            return [{
              type: 'ANSWER_INVALID_VALUE',
              id: field.id,
              message: `${answer} no es una opción válida.`
            }];
          }
          if (!field.hidden && field.required && _.contains(values_keys, 'otros - ') && !_.contains(values_keys, answer) &&!answer.includes('otros - ')) {
            return [{
              type: 'ANSWER_INVALID_VALUE',
              id: field.id,
              message: `${answer} no es una opción válida.`
            }];
          }
          return [];
        }
      },
      /**
         * File type field properties
         */
      file: {
        conditionals: ['empty', 'equals'],
        validators: [],
        widgets: ['file'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Multiselect type field properties
         */
      multiselect: {
        conditionals: ['empty', 'equals', 'contains'],
        validators: ['minLength', 'maxLength'],
        widgets: ['checkbox'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = [];
          let err;
          const values_keys = _.map(field.values, i => i.key);
          let diff = _.difference(answer, values_keys);

          if (diff.length) {
            if (values_keys.includes('otros - ')){
              diff = diff.filter(v => !v.includes('otros - '))
            }
            _.each(diff, (d) => {
              err = {
                type: 'ANSWER_INVALID_VALUE',
                id: field.id,
                message: `${d} no es una opción válida.`
              };
              errors = errors.concat(err);
            });
          }

          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },

            /**
         *  Matrix type field properties
         */
        matrix: {
          conditionals: ['empty', 'equals', 'contains'],
          validators: [],
          widgets: ['radio','checkbox'],
          validate(field, obj) {
            return _validateField(field, obj, this);
          },

          validateAnswer(field, answer) {
            let errors = [];
            let err;
            const field_rows = _.map(field.rows, r => r.key);
            const field_columns = _.map(field.columns, c => c.key);

            const answer_rows = Object.keys(answer);
            const answer_columns = Object.values(answer).flat()

            const diff_rows = _.difference(answer_rows,field_rows);
            const diff_cols = _.difference(answer_columns,field_columns);

            if(field.widget === 'radio'){
              if(answer_rows.length !== answer_columns.length){
                err = {
                  type: 'ANSWER_INVALID_VALUE',
                  id: field.id,
                  message: `Checkbox no es una opción válida.`
                };
                errors = errors.concat(err);              }
            }

            if (diff_rows.concat(diff_cols).length) {
              _.each(diff_rows, (d) => {
                err = {
                  type: 'ANSWER_INVALID_VALUE',
                  id: field.id,
                  message: `${d} no es una opción válida.`
                };
                errors = errors.concat(err);
              });
            }
            return errors;
          }
        },


      /**
         * Email type field properties
         */
      email: {
        conditionals: ['empty', 'equals', 'startsWith', 'endsWith', 'contains'],
        validators: ['minLength', 'maxLength', 'contains'],
        widgets: ['charfield'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'string');
          // checking if it is a valid email
          if (!/^[^@]+@[^@]+$/.test(answer)) {
            errors = errors.concat({
              type: 'ANSWER_INVALID_EMAIL',
              id: field.id,
              message: 'No es un email válido'
            });
          }
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Zipcode type field properties
         */
      zipcode: {
        conditionals: ['empty', 'equals'],
        validators: [],
        widgets: ['charfield'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'string');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Url type field properties
         */
      url: {
        conditionals: ['empty', 'equals', 'startsWith', 'endsWith', 'contains'],
        validators: [],
        widgets: ['charfield'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'string');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Position type field properties
         */
      position: {
        conditionals: ['empty', 'equals', 'maxDistanceTo', 'minDistanceTo'],
        validators: [],
        widgets: ['map', 'currentPosition'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Float type field properties
         */
      float: {
        conditionals: ['empty', 'equals', 'greater', 'greaterEqual', 'lesserEqual', 'lesser'],
        validators: ['minValue', 'maxValue'],
        widgets: ['charfield', 'numberfield'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Password type field properties
         */
      password: {
        conditionals: ['empty', 'equals', 'startsWith', 'endsWith', 'contains'],
        validators: ['minLength', 'maxLength'],
        widgets: ['charfield'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          let errors = _checkAnswerType(field, answer, 'string');
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      },
      /**
         * Image type field properties
         */
      image: {
        conditionals: ['empty', 'equals'],
        validators: ['maxSize', 'fileTypes'],
        widgets: ['file'],
        validate(field, obj) {
          return _validateField(field, obj, this);
        },

        validateAnswer(field, answer) {
          // TODO: check Answer types
          let errors = [];
          if ('validators' in field) {
            errors = errors.concat(_checkAnswerValidations(field, answer));
          }
          return errors;
        }
      }
    };
  });

  /* jshint camelcase: false */

  define('Conditionals', ['exports', 'Utils', 'Fields'], (exports, Utils, Fields) => {
	  const checkConditionals = function (field, conditionals, obj) {
      let errors = [];
      let ref_field;
      debugger;
      if (field.conditionals && field.conditionals.length !== 0){
        _.each(field.conditionals, function(con){

            // check conditional required keys
            var diff = _.difference(['type','state'], Object.keys(con));

            diff.forEach(function(d){
                errors.push(Utils.generate_error('CONDITIONAL_REQUIRED_KEY', field.id, d));
            });

            if (diff.length === 0){
                if (con.type === 'all' || con.type === 'any') {
                    // if condition type is 'all' or 'any' it check if  a condition list is given, and
                    // no field key is given.
                    if (con.field !== undefined || con.conditionList === undefined){
                        errors.push(Utils.generate_error('CONDITIONAL_WRONG_SCHEMA', field.id, con.type));
                    }else{
                        /**
                         * Check conditional list fields. Is the same flow that parent conditionals
                         * but it doesn't check states and conditional lists
                         */
                        errors = _checkConditionalList(con, field, obj);
                    }
                } else {
                    // check if conditional fields are correct with their condition
                    ref_field = _.find(obj.fields, function(item){
                        return item.id === con.field;
                    });
                    if (ref_field) {
                      if (!_.contains(Fields[ref_field.type].conditionals, con.type)){
                          errors.push(Utils.generate_error('FIELD_CONDITIONAL_ERROR', field.id, con.type));
                      }
                    }else {
                      errors.push(Utils.generate_error('CONDITIONAL_FIELD_NOT_FOUND', field.id, con.field));
                    }
                }
            }
        });

      }
      return errors;
    };

    var _checkConditionalList = function (con, field, obj) {
      const errors = [];
      let diff; let
        ref_field;

      _.each(con.conditionList, (conlst) => {
        diff = _.difference(['type', 'field'], Object.keys(conlst));
        diff.forEach((d) => {
          errors.push(Utils.generate_error('CONDITIONAL_REQUIRED_KEY', field.id, d));
        });

        if (diff.length === 0) {
          // check if conditional fields are correct with their condition
          ref_field = _.find(obj.fields, item => item.id === conlst.field);

          // check if the field actually exist
          if (ref_field) {
            if (!_.contains(Fields[ref_field.type].conditionals, conlst.type)) {
              errors.push(Utils.generate_error('FIELD_CONDITIONAL_ERROR', field.id, conlst.type));
            }
          } else {
            errors.push(Utils.generate_error('CONDITIONAL_FIELD_NOT_FOUND', field.id, conlst.field));
          }
        }
      });
      return errors;
    };

    exports.check = checkConditionals;
  });

  /* jshint camelcase: false */


  define('FormValidator',
    ['exports', 'Utils', 'Conditionals', 'Defaults', 'Fields'],
    (exports, Utils, Conditionals, Defaults, Fields) => {
      let form;

      /**
       * check types of first level fields
       */
      const _checkFirstLevelTypes = function (obj) {
        let error_object = [];
        error_object = Utils.checkTypes(Defaults.schema, obj);
        return error_object;
      };

      /**
       * check pages field
       * @field: this is the page field that you want to check.
       */
      const _checkPages = function (field, obj) {
        let error_object = [];
        error_object = Utils.checkDuplicates(field);
        const used_sections = []; // to check duplicated sections between pages

        field.forEach((page) => {
          const keys = Object.keys(page);

          // checking page required keys
          const diff = _.difference(['id', 'title', 'content'], keys);
          if (diff.length > 0) {
            diff.forEach((i) => {
              error_object.push(Utils.generate_error('PAGE_REQUIRED_KEY', page.id, i));
            });
          } else {
            error_object = error_object.concat(Utils.checkTypes(Defaults.schema.pages.child, page));
            // if there is some type errors, return form invalid.
            if (error_object.length > 0) {
              return error_object;
            }
            // check if all sections exists.
            page.content.forEach((cont) => {
              if (_.findWhere(form.sections, { id: cont }) === undefined) {
                if (_.findWhere(form.fields, { id: cont }) === undefined) {
                  error_object.push(Utils.generate_error('SECTION_NOT_FOUND', page.title, cont));
                }
              }
              if (_.contains(used_sections, cont)) {
                error_object.push(Utils.generate_error('PAGE_DUPLICATED_SECTION', page.id, cont));
              } else {
                used_sections.push(cont);
              }
            });

            // CHECK CONDITIONAL IN PAGES
            error_object = error_object.concat(Conditionals.check(page, null, obj));
          }
        });

        // Check if there are sections that are not included in a page
        const all_sections = _.map(form.sections, i => i.id);

        _.difference(all_sections, used_sections).forEach((se) => {
          error_object.push(Utils.generate_error('SECTION_WITHOUT_PAGE', null, se));
        });

        return error_object;
      };

      /**
       * check sections field
       * @field: this is the section field that you want to check.
       */
      const _checkPageContent = function (pageList, sectionList, obj) {
        let error_object = [];
        error_object = Utils.checkDuplicates(sectionList);
        const used_fields = []; // to check duplicated fields between sections

        sectionList.forEach((section) => {
          const keys = Object.keys(section);
          // checking section required keys
          const diff = _.difference(['title', 'fields', 'id'], keys);
          if (diff.length > 0) {
            diff.forEach((i) => {
              error_object.push(Utils.generate_error('SECTION_REQUIRED_KEY', section.id, i));
            });
          } else {
            const type_error_object = Utils.checkTypes(Defaults.schema.sections.child, section);
            // if there is some type errors, return form invalid.
            if (type_error_object.length > 0) {
              return error_object.concat(type_error_object);
            }
            // check if all fields exists.
            section.fields.forEach((f) => {
              if (_.findWhere(form.fields, { id: f }) === undefined) {
                error_object.push(Utils.generate_error('FIELD_NOT_FOUND', section.id, f));
              }
              if (_.contains(used_fields, f)) {
                error_object.push(Utils.generate_error('SECTION_DUPLICATED_FIELD', section.id, f));
              } else {
                used_fields.push(f);
              }
            });

            // CHECK CONDITIONAL IN SECTIONS
            error_object = error_object.concat(Conditionals.check(section, null, obj));
          }
        });

        // Check if there are fields that are not included in a section
        const all_fields = _.map(form.fields, i => i.id);

        const pageIDs = _.flatten(_.map(pageList, p => _.map(p.content, c => c)));

        _.difference(all_fields, used_fields).forEach((fi) => {
          if (!_.contains(pageIDs, fi)) {
            error_object.push(Utils.generate_error('FIELD_WITHOUT_SECTION', null, fi));
          }
        });

        return error_object;
      };

      /**
       * validate a form field.
       * @field: this is the field that you want to validate.
       */
      const _checkField = function (field, obj) {
        let error_object = [];

        // checking valid keys
        const keys = Object.keys(field);
        let diff = _.difference(keys, Defaults.field_keys);
        if ((diff.length > 0)) {
          error_object.push(
            Utils.generate_error(
              'NOT_VALID_KEY',
              field.id,
              diff
            )
          );
        }
        // checking required keys
        diff = _.difference(Defaults.required_field_keys, keys);
        if (diff.length > 0) {
          error_object.push(
            Utils.generate_error(
              'FIELD_REQUIRED_KEY',
              field.id,
              diff
            )
          );
        }

        // if there are missing required keys, the form is invalid and return the error list.
        if (error_object.length > 0) {
          return error_object;
        }

        // checking types
        error_object = Utils.checkTypes(Defaults.schema.fields.child, field);


        // if there are error types, the form is invalid and return the error list.
        if (error_object.length > 0) {
          return error_object;
        }

        try {
          error_object = Fields[field.type].validate(field, obj);
        } catch (raised_error) {
          // check if the field type is correct.
          error_object.push(
            Utils.generate_error('FIELD_TYPE_ERROR', field.id, field.type)
          );

          throw raised_error;
        }

        return error_object;
      };

      /**
       * validator. Here comes the magic.
       */
      const validate = function (obj) {
        form = obj;
        let err = [];
        if (typeof (obj) !== 'object') {
          // input of validator is not an object.
          return {
            result: 'FORMAT_ERROR',
            errors: Utils.generate_error('NOT_OBJECT_ERROR', null, typeof (obj))
          };
        }


        // Check missing keys on schema. If there are inconsistences returns
        // an array containing the errors.
        const keys = Object.keys(obj);
        const diff = _.difference(Defaults.requiredKeys, keys);

        if (diff.length > 0) {
          // Missing keys in json
          diff.forEach((i) => {
            err = err.concat(Utils.generate_error('FORM_REQUIRED_KEY', null, i));
          });

          return {
            result: 'FORMAT_ERROR',
            errors: err
          };
        }


        // Check mismatching types on schema. If there are inconsistences returns
        // an array containing the errors.
        err = _checkFirstLevelTypes(obj);
        if (err.length > 0) {
          // some type errors with first level
          return {
            result: 'FORMAT_ERROR',
            errors: err
          };
        }


        // Check validation on pages, sections and fields
        // in first field error return the errors.
        err = err.concat(Utils.checkDuplicates(obj.fields));
        obj.fields.every((f) => {
          const errf = _checkField(f, obj);
          err = err.concat(errf);
          return errf.length === 0;
        });

        err = err.concat(_checkPageContent(obj.pages, obj.sections, obj));
        err = err.concat(_checkPages(obj.pages, obj));

        if (err.length > 0) {
          return {
            result: 'SCHEMA_ERROR',
            errors: err
          };
        }
        return {
          result: 'OK',
          message: 'The form is valid.'
        };
      };

      exports.validate = validate;
    });

  /* jshint camelcase: false */

  define('AnswerValidator',
    ['exports', 'Fields'],
    (exports, Fields) => {
   	const validate = function (obj, ans, autocompletado) {
   		let errors = [];
   		let err;
   		// getting Form field list
   		const form_fields = _.map(obj.fields, i => i.id);
   		let answer_fields = _.map(ans, (v, k) => {

         const field = obj.fields.find(f => f.id === k);
         if(field && field.type === 'matrix'){
           if(field.widget.type === 'radio' && field.rows.length === Object.keys(ans[field.id]).length){
             return k
           }
           if(field.widget.type !== 'radio' && Object.keys(ans[field.id]).length > 0){
             return k
           }
         }

        if (field && v !== '' && field.type !== 'matrix') { return k;}

      });
       answer_fields = _.without(answer_fields, undefined);

   		// check for answer's fields that are not part of the form specification
   		let diff = _.difference(answer_fields, form_fields);
   		diff.forEach((d) => {
   			err = {
            type: 'ANSWER_INVALID_FIELD',
            id: d,
            message: 'The field is not in the form schema'
          };
   			errors = errors.concat(err);
   		});
   		if (errors.length) {
   			return {
   				result: 'ANSWER_ERROR',
   				errors
   			};
   		}
   			let field_spec;
   			// iterate over fields of an answer.
	   		_.each(form_fields, (key) => {
          field_spec = _.find(obj.fields, item => item.id === key);

          // apply the conditionals
	   			_applyAnswerConditionals(obj, field_spec, ans);
          errors = errors.concat(Fields[field_spec.type].validateAnswer(field_spec, ans[key]));
	   		});


      // check for required answers
      // FIXME: Validacion de campos requeridos erronea. Se debería solucionar evitando mostrar el campo
      let required_fields = _.map(obj.fields, (i) => {
        if (i.required === true && (!('hidden' in i) || i.hidden === false)){
          if (autocompletado && i.pollster){
            // no es requerida
          } else {
            return i.id;
          }
        }
      });
   		required_fields = _.without(required_fields, undefined);


      diff = _.difference(required_fields, answer_fields);

   		diff.forEach((d) => {
   			err = {
            type: 'ANSWER_REQUIRED_FIELD',
            id: d,
            message: 'Este campo es requerido'
          };
   			errors = errors.concat(err);
   		});

   		if (errors.length) {
   			return { result: 'ANSWER_ERROR', errors };
   		}
   			return { result: 'OK', message: 'The answer is valid.' };
   	};

   	/**
   	* Applies the states given by the conditionals fields. Currently
   	* only applies hidden state.
   	* @method _applyAnswerConditionals
   	* @param {Object} obj: the form specification.
   	* @param {Object} field: field to validate
   	* @param {Object} answer: answer to check and apply the state conditions
   	*/
   	var _applyAnswerConditionals = function (obj, field, answer) {
   	 	// TODO: Make it extendable for others states.
   	 	let field_index = -1;
	 	_.each(obj.fields, (e, idx) => {
	 		if (e.id === field.id) {
	 			field_index = idx;
	 		}
	 	});
        _.each(field.conditionals, (c) => {
            	switch (c.type) {
            case 'empty':
              if (answer[c.field]) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'equals':
              if (answer[c.field] === c.value) {
                if ("hidden" in c.state) {
                  obj.fields[field_index].hidden = c.state.hidden;
                }
                if ("required" in c.state) {
                  obj.fields[field_index].required = c.state.required;
                }
              } else {
                obj.fields[field_index].hidden = !c.state.hidden;
                obj.fields[field_index].required = !c.state.required;
              }
              break;
            case 'startsWith':
              if (answer[c.field].startsWith(c.value)) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'endsWith':
              if (answer[c.field].endsWith(c.value)) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'contains':
              if (answer[c.field].indexOf(c.value) > -1) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'greater':
              if (answer[c.field] > c.value) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'greaterEqual':
              if (answer[c.field] >= c.value) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'lesserEqual':
              if (answer[c.field] < c.value) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'lesser':
              if (answer[c.field] <= c.value) {
                obj.fields[field_index].hidden = c.state.hidden;
              }
              break;
            case 'before':
            case 'after':
            case 'maxDistanceTo':
            case 'minDistanceTo': break;
          }
        });
      };

   	exports.validate = validate;
    });

  /* jshint camelcase: false */

  define('defaults', [], () => {
    const defaultObject = {};
    /**
   * form schema. It has all the posibles keys with it's types associated.
   */
    defaultObject.schema = {
      id: { type: 'string' },
      version: { type: 'number' },
      fields: {
        type: 'Array', // type of fields property
        child: { // content of an item of field property
          type: { type: 'string' },
          id: { type: 'string' },
          title: { type: 'string' },
          tooltip: { type: 'string' },
          values: { type: 'Array' },
          required: { type: 'boolean' },
          hidden: { type: 'boolean' },
          widget: { type: 'object' },
          validators: { type: 'Array' },
          conditionals: { type: 'Array' },
          default: { type: 'Any' }
        }
      },
      sections: {
        type: 'Array',
        child: {
          title: { type: 'string' },
          id: { type: 'string' },
          fields: { type: 'Array' },
          conditionals: { type: 'Array' },
          hidden: { type: 'boolean' }
        }
      },
      pages: {
        type: 'Array',
        child: {
          title: { type: 'string' },
          id: { type: 'string' },
          content: { type: 'Array' },
          conditionals: { type: 'Array' }
        }
      }
    };

    defaultObject.requiredKeys = Object.keys(defaultObject.schema);

    /**
   * available keys for a form field
   */
    defaultObject.field_keys = Object.keys(defaultObject.schema.fields.child);

    /**
   * the required keys for a form field.
   */
    defaultObject.required_field_keys = [
      'id', 'type', 'title'
    ];

    defaultObject.errors = {
    /**
     * When the object form doesn't follow the schema
     * @variables This key takes one variable: The missing keys.
     */
      FORM_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the schema.',
      /**
     * When the form is not an object
     * @variables This key takes one variable: The type of the form.
     */
      NOT_OBJECT_ERROR: 'The element is not a json object. Got {{0}}',
      /**
     * When a field's type doesn't match with the specified in the schema
     * @variables This key takes three variables: The field that generate the error, the expected type, and the type given.
     */
      TYPE_ERROR: '{{field}} type doesn\'t match with field type in schema. Expected {{0}}, got {{1}}',
      /**
     * When a field type inside a form field doesn't match with the availables field types.
     * @variables This key takes three variables: The field that generate the error, the expected type, and the type given.
     */
      FIELD_TYPE_ERROR: 'Invalid field type: \'{{0}}\'',
      /**
     * When a section specified in a page not exists
     * @variables This key takes two variables: The field that generate the error, and the section id.
     */
      SECTION_NOT_FOUND: 'Section \'{{0}}\' doesn\'t exists.',

      FIELD_NOT_FOUND: 'Field \'{{0}}\' doesn\'t exists.',
      /**
     * When a required key is missing in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is missing.
     */
      DUPLICATED_ERROR: '\'{{0}}\' is duplicated.',

      /**
     * When a field is duplicated between sections
     * @variables This key takes one variables: The field id that is duplicated.
     */
      SECTION_DUPLICATED_FIELD: '\'{{0}}\' field is already in another section.',
      /**
     * When a section is duplicated between pages
     * @variables This key takes one variable: The section id that is duplicated.
     */
      PAGE_DUPLICATED_SECTION: '\'{{0}}\' section is already in another page.',
      /**
     * When a required key is missing in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is missing.
     */
      REQUIRED_KEY: 'The Field is missing the required property \'{{0}}\'',
      /**
     * When a required key is missing in a form section.
     * @variables This key takes one variable: the key that is missing.
     */
      PAGE_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the page schema.',

      SECTION_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the section schema.',

      FIELD_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the field schema.',
      /**
     * When a key is invalid in a form field.
     * @variables This key takes two variables: The field that generate the error, and the key that is invalid.
     */
      NOT_VALID_KEY: 'Key \'{{0}}\' doesn\'t belong in the schema',

      FIELD_CONDITIONAL_ERROR: 'Conditional \'{{0}}\' is invalid for the referenced field',

      FIELD_VALIDATOR_ERROR: 'Validator \'{{0}}\' is invalid for the field type.',

      FIELD_WIDGET_ERROR: 'Wigdet \'{{0}}\' is invalid for this field type.',

      NO_VALUES_ERROR: 'Select Field type must have a list of values',

      WRONG_FORMED_VALUES: 'Select Values must be an object (key, value)',

      CONDITIONAL_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the conditional schema.',

      VALIDATOR_REQUIRED_KEY: 'Required key \'{{0}}\' is missing from the validator schema.',

      VALIDATOR_INVALID_KEY: 'Key \'{{0}}\' doesn\'t belong in the validator schema',

      CONDITIONAL_WRONG_SCHEMA: 'Conditional \'{{0}}\' type must have only a conditional list and no field key.',

      CONDITIONAL_FIELD_NOT_FOUND: 'Field \'{{0}}\' inside conditionals doesn\'t exists.',

      FIELD_WITHOUT_SECTION: 'Field \'{{0}}\' does not belong to any Section.',

      SECTION_WITHOUT_PAGE: 'Section \'{{0}}\' does not belong to any Page.',

      VALIDATOR_INVALID_VALUE: 'Value \'{{0}}\' is invalid for this validator type.'
    };

    return defaultObject;
  });
  define('PulpoValidator', [
    'FormValidator',
    'AnswerValidator',
    'defaults'
  ], (FormValidator, AnswerValidator, defaults) => {
    // Object Contructor
    const PulpoValidator = function (obj) {
      return obj;
    };

    // Methods
    PulpoValidator.validate = FormValidator.validate;
    PulpoValidator.validateAnswer = AnswerValidator.validate;
    PulpoValidator.defaults = defaults;

    return PulpoValidator;
  });

  // Ask almond to synchronously require the
  // module value for 'mylib' here and return it as the
  // value to use for the public API for the built file.
  return require('PulpoValidator');
}));

// # sourceMappingURL=pulpovalidator.js.map
